import React from 'react';

//Components
import WpBadge from 'Wpds/components/badge/WpBadge';
import { WpIcon } from 'Wpds/components/icon';
import { WpTooltip, WpTooltipContent, WpTooltipTrigger } from 'Wpds/components/tooltip';

type Props = {
  receiverName?: string;
};
const PrivateQuestionPopover = ({ receiverName = 'the receiver' }: Props) => {
  return (
    <WpTooltip>
      <WpTooltipTrigger>
        <WpBadge color="yellow">
          <WpIcon name="eye-slash"></WpIcon>Private
        </WpBadge>
      </WpTooltipTrigger>
      <WpTooltipContent>
        Only you and Perform Admins will be able to see this. This will not be shared with {receiverName}.
      </WpTooltipContent>
    </WpTooltip>
  );
};

export default PrivateQuestionPopover;
